import { LitElement as d, unsafeCSS as c } from "lit";
import { property as s } from "lit/decorators.js";
import { booleanType as n } from "../../utils/property-types.js";
import u from "./tabs-panel.style.css.js";
import { tabsPanelTemplate as _ } from "./tabs-panel.template.js";
var f = Object.defineProperty, b = Object.getOwnPropertyDescriptor, r = (a, e, t, o) => {
  for (var l = o > 1 ? void 0 : o ? b(e, t) : e, h = a.length - 1, p; h >= 0; h--)
    (p = a[h]) && (l = (o ? p(e, t, l) : p(l)) || l);
  return o && l && f(e, t, l), l;
};
class i extends d {
  constructor() {
    super(...arguments), this._panelId = "", this._label = "", this._linkedTo = "", this._selected = !1, this._hasScroll = !1, this.fullHeight = !1;
  }
  static get styles() {
    return c(u);
  }
  set panelId(e) {
    const t = this._panelId;
    this._panelId = e, this.requestUpdate("panelId", t);
  }
  get panelId() {
    return this._panelId;
  }
  set label(e) {
    const t = this._label;
    this._label = e, this.requestUpdate("label", t);
  }
  get label() {
    return this._label;
  }
  set linkedTo(e) {
    const t = this._linkedTo;
    this._linkedTo = e, this.requestUpdate("linkedTo", t);
  }
  get linkedTo() {
    return this._linkedTo;
  }
  set selected(e) {
    const t = this._selected;
    this._selected = e, this.requestUpdate("selected", t);
  }
  get selected() {
    return this._selected;
  }
  set hasScroll(e) {
    const t = this._hasScroll;
    this._hasScroll = e, this.requestUpdate("hasScroll", t);
  }
  get hasScroll() {
    return this._hasScroll;
  }
  updated(e) {
    e.has("selected") && this.fullHeight && (this.selected ? this.classList.add("visible-full-height") : this.classList.remove("visible-full-height"));
  }
  render() {
    return _(this);
  }
}
r([
  s({ type: String })
], i.prototype, "panelId", 1);
r([
  s({ type: String })
], i.prototype, "label", 1);
r([
  s({ type: String })
], i.prototype, "linkedTo", 1);
r([
  s(n)
], i.prototype, "selected", 1);
r([
  s(n)
], i.prototype, "hasScroll", 1);
r([
  s(n)
], i.prototype, "fullHeight", 2);
export {
  i as TabsPanel
};
//# sourceMappingURL=tabs-panel.js.map
